<ion-grid class="ion-no-padding">
  <ion-row>
    <ng-container *ngFor="let dish of popularDishesCategory?.children; let i = index; ; let lastItem = last" >
    <ion-col size-xs="12" size-md="6" size-xl="3" style="padding-right:20px;" style.margin-bottom.px="lastItem?0;40">
      <div class="popular-dishes fake-card__first" >
        <ion-img class="popular-dishes__img" [src]="dish.avatar?.document?.fileName | ppImage"></ion-img>
        <h4 class="popular-dishes__name">{{ dish?.name | ppTranslate:dish?.nameTranslations:translateService.currentLang }}</h4>
        <p class="popular-dishes__price ion-float-right">{{ dish?.minimalPrice.lowestPrice | number:'1.2-2' }} €</p>
        <p class="popular-dishes__subtitle">{{ dish?.shortDescription | ppTranslate:dish?.shortDescriptionTranslations:translateService.currentLang }}</p>
        <p class="popular-dishes__desc">{{ dish?.longDescription | ppTranslate:dish?.longDescriptionTranslations:translateService.currentLang }}</p>
      </div>
    </ion-col>
    </ng-container>
  </ion-row>
</ion-grid>